import React, { useState } from 'react';
import styles from './furnishingContainer.module.scss';
import { FurnishingPackageCard } from './components/FurnishingPackageCard';
import Modal from '../shared/components/core-ui/modal/modal.component';
import type { FurnishingPackage } from './types';

interface FurnishingPackageCardsProps {
  packages: FurnishingPackage[];
  displayLanguage: 'en' | 'ar';
  onPackagesChange: (next: FurnishingPackage[]) => void;
}

const FurnishingPackageCards: React.FC<FurnishingPackageCardsProps> = ({
  packages,
  displayLanguage,
  onPackagesChange
}) => {
  const [confirmDialog, setConfirmDialog] = useState<{
    show: boolean;
    title: string;
    message: string;
    onConfirm: () => void;
  }>({
    show: false,
    title: '',
    message: '',
    onConfirm: () => {
      return;
    }
  });

  const showConfirmDialog = (title: string, message: string, onConfirm: () => void) => {
    setConfirmDialog({ show: true, title, message, onConfirm });
  };

  const hideConfirmDialog = () => {
    setConfirmDialog({
      show: false,
      title: '',
      message: '',
      onConfirm: () => {
        return;
      }
    });
  };

  const handleConfirm = () => {
    confirmDialog.onConfirm();
    hideConfirmDialog();
  };

  const handlePackageUpdate = (updatedPkg: FurnishingPackage) => {
    onPackagesChange(packages.map((pkg) => (pkg.id === updatedPkg.id ? updatedPkg : pkg)));
  };

  const handlePackageRemove = (packageId: string) => {
    onPackagesChange(packages.filter((pkg) => pkg.id !== packageId));
  };

  return packages?.length > 0 ? (
    <>
      <div className={styles['furnishing-management__cards']}>
        {packages.map((pkg) => (
          <FurnishingPackageCard
            key={pkg.id}
            pkg={pkg}
            displayLanguage={displayLanguage}
            onPackageUpdate={handlePackageUpdate}
            onPackageRemove={handlePackageRemove}
            onConfirmDialog={showConfirmDialog}
          />
        ))}
      </div>

      <Modal
        config={{
          showModal: confirmDialog.show,
          fullScreen: false,
          maxWidth: 'sm',
          showClose: false
        }}
        eventHandlers={{
          closeModalHandler: hideConfirmDialog
        }}
      >
        <div className={styles['furnishing-management__confirm-dialog']}>
          <h2>{confirmDialog.title}</h2>
          <p>{confirmDialog.message}</p>
          <div className={styles['furnishing-management__confirm-dialog-actions']}>
            <button
              type="button"
              onClick={hideConfirmDialog}
              className={styles['furnishing-management__cancel-btn']}
            >
              Cancel
            </button>
            <button
              type="button"
              onClick={handleConfirm}
              className={styles['furnishing-management__delete-confirm-btn']}
            >
              Delete
            </button>
          </div>
        </div>
      </Modal>
    </>
  ) : (
    <div className={styles['furnishing-management__empty']}>
      <p>No packages yet.</p>
    </div>
  );
};

export default FurnishingPackageCards;
